import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, TimePicker, Form, Input } from 'antd';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {app} from '../../config';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
const { TextArea } = Input;
const Addprayer = () => {
  dayjs.extend(customParseFormat);
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [addUserResp,setAddUserResp] = useState({});
  const [show, setShow] = useState(false); 
  let user=JSON.parse(localStorage.getItem('user'));
  console.log(user);
  const token= getTokenfromUserObj()
  let navigate = useNavigate();
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/prayertime/add`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode===200){
        setAddUserResp(res.data)
        setTimeout(()=>{
          if(user.userType==="A")navigate('/prayer/view', { replace: true });
          else if(user.userType==="O")navigate('/prayers/view', { replace: true });
        },1000)
      } 
    } catch (err) {
      console.log(err);
    }
  }

  const onFinish = (values) => {
    console.log('Success:', values);
    setUploadObj({
      prayer: values.prayer ? values.prayer : '',
      organizationId:  user.userType==="A" && values.organizationId ? values.organizationId : user.organizationId,
      comment:values.comment ? values.comment:null,
      startTime:values.startTime  ? (values.startTime._d).toTimeString().split(' ')[0] : '',
      endTime:values.endTime  ? (values.endTime._d).toTimeString().split(' ')[0] : '',
      iqamahTime:values.iqamahTime  ? (values.iqamahTime._d).toTimeString().split(' ')[0]: '',
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
    setShow(true);
  };
  console.log(uploadObj);
  // if(Object.keys(uploadObj).length>0){
  //     console.log(true)
  //     uploadData(uploadObj);
  // }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const submitData=()=>{
    console.log('calling')  
    if (Object.keys(uploadObj).length > 0) {
          uploadData(uploadObj);
  }
}
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

  function goBack() {
    if(user.userType==="A")navigate('/prayer/view', { replace: true });
    else if(user.userType==="O")navigate('/prayers/view', { replace: true });
   }
   window.addEventListener('popstate', goBack);
  return (
<div class='container '>
<div class='row mt-4 w-75 tbl'>
<div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
              
            <LeftCircleOutlined
              onClick={() => {
                if(user.userType==="A")navigate('/prayer/view', { replace: true });
                else if(user.userType==="O")navigate('/prayers/view', { replace: true });
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Add Prayer')} </h2>
          </div>{' '}
        </div>
  <div class="col-lg-11 mb-5 mt-4 ">
  <div class='col-lg-9 align-self-center mt-2 mb-4'>
    <Form
      name='basic'
      labelCol={{
        span: 8,
      }}
      wrapperCol={{
        span: 16,
      }}
      style={{
        maxWidth: 600,
      }}
      initialValues={{
        remember: true,
        ['id']: 1,
        ['causename']: 'Hammad',
        ['isActive']: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete='off'
    >
      {user.userType==="A"?<Form.Item
        label='Organization'
        name='organizationId'
        rules={[
          {
            required: true,
            message: 'Select organization',
          },
        ]}
      >
        <Select
          listHeight={250}
          listItemHeight={500}
          placeholder="Select Organization"
          style={{
            width: 260,
          }}
        >
          {orgs.map((orgs) => {
            return (
              <Option key={orgs.organizationId} value={orgs.organizationId}>
                {orgs.organizationName}
              </Option>
            );
          })}
        </Select>
      </Form.Item>:" "}   
      <Form.Item  
        colon={false}
        label='Prayer Name'
        name='prayer'
        rules={[
          {
            required: true,
            message: 'Enter Prayer Name',
          },
        ]}
      >
        <Input placeholder='Enter Prayer Name' maxLength={20} />
      </Form.Item>
      <Form.Item  
        colon={false}
        label='Comment'
        name='comment'
        rules={[
          {
            required: false,
            message: 'Enter Prayer Name',
          },
        ]}
      >
        <Input placeholder='Enter comments' />
      </Form.Item>
      <Form.Item
        colon={false}
        label='Start Time'
        name='startTime'
        rules={[
          {
            required: true,
            message: 'Select Start Time',
          },
        ]}
      >
         <TimePicker style={{width:160}} placeholder='Select Start Time' />
      </Form.Item>
      <Form.Item
        colon={false}
        label='End Time'
        name='endTime'
        rules={[
          {
            required: true,
            message: 'Select End Time',
          },
        ]}
      >
         <TimePicker style={{width:160}} placeholder='Select End Time' />
      </Form.Item>
      <Form.Item
        colon={false}
        label='Iqamah Time'
        name='iqamahTime'
        rules={[
          {
            required: false,
            message: 'Select Iqamah Time',
          },
        ]}
      >
         <TimePicker style={{width:160}} placeholder='Select Iqamah Time' />
      </Form.Item>
      <Form.Item label='Active'   colon={false} valuePropName='checked' name='isActive'>
        <Switch />
      </Form.Item>
      {/* <Form.Item
        label='Description'
        name='description'
        rules={[
          {
            message: 'Please input your password!',
          },
        ]}
      >
        <TextArea rows={4} />
      </Form.Item> */}

      <Form.Item
        colon={false}
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
              {addUserResp.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>:addUserResp.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to add Prayer?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}
        <button type='primary' class='btn btn-primary button' htmlType='submit'>
          Add
        </button>
      </Form.Item>
    </Form>
  </div>
  </div>
</div>
</div>
  );
};

export default Addprayer;
